import React from 'react';

import { useClaimContext } from '~/components/Claim/ClaimContext';
import ClaimPageBody from '~/components/Claim/ClaimPageBody';
import UpperChatPanel from '~/components/Claim/UpperChatPanel';
import { useAuth } from '~/context/AuthContext.tsx';

const ClaimPageBodyWrapper: React.FC = () => {
  const { handleChatMessage } = useClaimContext();
  const { user } = useAuth();

  return (
    <>
      <div className="bg-gradient-2 text-gray-700">
        <UpperChatPanel userName={user?.name} onSubmit={handleChatMessage} />
      </div>
      <ClaimPageBody />
    </>
  );
};

export default ClaimPageBodyWrapper;
